import { Grid2, Box, Typography, Radio } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { Country } from "../../../../../store/useMarketplaceStore";

type CountryBoxProps = {
  country: Country;
};

export const CountryBox = (props: CountryBoxProps) => {
  const { country } = props;

  const { control } = useFormContext();

  return (
    <Grid2 size={2}>
      <Controller
        name="country"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <Box
            onClick={() => field.onChange(country)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor:
                field.value?.id === country.id ? "primary.main" : "lightgray",
              borderRadius: "8px",
              paddingTop: "12px",
              cursor: "pointer",
              flexDirection: "column",
            }}
          >
            <img
              src={country.flagUrl + "?width=120"}
              alt={`${country.countryName} flag`}
              style={{ height: "40px", width: "60px", padding: "4px" }}
            />
            <Typography
              variant="caption"
              textAlign="center"
              padding="0px 4px"
              textOverflow="ellipsis"
            >
              {country.countryName}
            </Typography>
            <Radio
              size="small"
              value={country.id}
              checked={field.value?.id === country.id}
            />
          </Box>
        )}
      />
    </Grid2>
  );
};
